import { createStyles, Grid, IconButton, LinearProgress, makeStyles, Theme } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import FormTextBox from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import { FormPricingField } from "../../../yoello-lib/modules/dynamicForms/CustomFormComponents/FormPricingField";
import { useWatch } from "react-hook-form";

export interface ICollectionPoint {
    id?: string;
    name: string;
    enabled: boolean;
    deleted?: boolean;
}
const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        Iconbutton: {
            color: "#C1CAE1",
            padding: "0.5rem 0 0 1rem",
            transition: "0.2s ease-in-out",
            "&:hover": {
                color: "#A7AEBF"
            },
            "&:active": {
                color: "#9BA0AE"
            }
        },
        extendedIcon: {
            marginRight: theme.spacing(1),
        },
        text: {
            color: theme.palette.error.main,
            fontSize: "0.75rem"
        }
    });
},
);

export function DeliveryFeeEntity(props: any) {
    const { keyName, index, disabled, onDelete,control } = props;
    const { Iconbutton } = useStyles();
    
    const deliveryFee = `${keyName}.${index}.amount`;
    const distance = `${keyName}.${index}.distance_from`;

    async function onDeleteHandler() {
            onDelete();
    }
 
    const [ deliveryFeeValue, distanceValue] = useWatch({
        control,
        name: [deliveryFee, distance]
    });
    const newProps={
        ...props,
        errors:props.errors && (Array.isArray(props.errors) ? props.errors[index] : props.errors),
        displaySymbol:true,
        value:deliveryFeeValue
    }
    
    return <>
        <Grid item xs={3} style={{ margin: "0 -4px" }}>
            <FormPricingField  {...newProps} inputProperties={{type:"number",}} label={undefined as any} data-component-name={"DELIVERY_FEE"} keyName={deliveryFee} />
        </Grid>
        <Grid item xs={4} style={{
            marginTop:"5px"
        }}>
            <FormTextBox {...newProps} value={distanceValue} label={undefined as any} keyName={distance} inputProperties={{
        type: "number",
        placeholder: "0",
        inputProps: { step: 1, min: 0 },
        required:true
      }} />
        </Grid>
        <Grid item xs={2}>
            {!disabled &&  index !== 0 && <IconButton className={Iconbutton} size="medium"
                onClick={onDeleteHandler}  color="primary">
                <DeleteIcon fontSize="large" />
            </IconButton>}
        </Grid>
        <Grid item xs={2} />
        {false &&
            <>
                <Grid item xs={9}>
                    <LinearProgress />
                </Grid>
                <Grid item xs={3} />
            </>
        }
    </>

}

export function createDeliveryFee() {
    return {
        amount: 0,
        distance_from: null,
    };
}